import qs from 'qs';
import { cleanParams } from '@casanova/casanova-common/lib/utils/requests';
import { sendCustomRequest } from '@casanova/casanova-common/lib/utils/service';
import { APIError } from '@casanova/casanova-common/lib/utils/exceptions';
import { customerRoot, priceQuoteRootV1 } from '../roots';
import transformer from './transformer';

const ROOT = 'pricequotes/v1';

export async function getDailyRentContracts(params) {
  const queryParams = `?${qs.stringify(cleanParams(params))}`;
  const endpoint = `${ROOT}/contracts/catalog${queryParams}`;
  const response = await sendCustomRequest(endpoint, {});
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  const { data = { content: [] } } = response.data;

  data.content = transformer(data.content);

  const result = data.content;
  result.forEach((el, i) => {
    result[i].contractNumber = `Z${el.contractNumber.padStart(8, '0')}`;
  });

  return data;
}

export async function getAllDailyRentContracts(params) {
  const initialResponse = await getDailyRentContracts({
    ...params,
    page: 0,
  });
  const { totalPages, size, content } = initialResponse;

  // Crea un array de promesas para todas las páginas restantes
  const requests = [];
  for (let i = 1; i < totalPages; i += 1) {
    requests.push(getDailyRentContracts({ ...params, page: i, size }));
  }

  // Espera a que todas las solicitudes se completen
  const responses = await Promise.all(requests);
  // Combina los datos de todas las páginas
  const allData = [...content, ...responses.flatMap((res) => res.content)];
  return allData;
}

export async function closeRDContract(contractUuid, validCodeRequest) {
  const url = `${priceQuoteRootV1}/contracts/${contractUuid}/close`;
  const response = await sendCustomRequest(url, {}, validCodeRequest, 'PUT');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function cancelRDContract(contractUuid, validCodeRequest) {
  const url = `${priceQuoteRootV1}/contracts/${contractUuid}/cancel`;
  const response = await sendCustomRequest(url, {}, validCodeRequest, 'PUT');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function getCloseDetailsOfCloseRDContract(contractUuid) {
  const url = `${priceQuoteRootV1}/contracts/${contractUuid}/close-details`;
  const response = await sendCustomRequest(url, {});
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function saveContractRefund(request) {
  const url = `${priceQuoteRootV1}/contracts/refund`;
  const response = await sendCustomRequest(url, {}, request, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }

  return response;
}

export async function saveContractPay(request) {
  const url = `${priceQuoteRootV1}/contracts/pay`;
  const response = await sendCustomRequest(url, {}, request, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }

  return response;
}

export async function getTotalPay(request) {
  const url = `${customerRoot}/billing-details/movement/pay/contract/${request.uuid}`;
  const response = await sendCustomRequest(url, {});
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }

  return response;
}

export async function postReservationExtendContract(body) {
  const url = `${priceQuoteRootV1}/contracts/extend`;
  const response = await sendCustomRequest(url, {}, body, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function getExtendedContracts(uuid) {
  const url = `${priceQuoteRootV1}/contracts/${uuid}/extend`;
  const response = await sendCustomRequest(url, {}, undefined, 'get');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function finishExtendContract(rcUuid, eUui) {
  const url = `${priceQuoteRootV1}/contracts/extend/${rcUuid}/${eUui}`;
  const response = await sendCustomRequest(url, {}, undefined, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data.data;
}

export async function reviewExpiredContracts() {
  const url = `${priceQuoteRootV1}/contracts/review-expired-contracts`;
  const response = await sendCustomRequest(url, {}, undefined, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }

  return response.data.data;
}

export async function cancelPromissoryNote(uuid) {
  const url = `${priceQuoteRootV1}/contracts/cancel-promissory-note/${uuid}`;
  const response = await sendCustomRequest(url, {}, undefined, 'put');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }
  return response.data;
}

export async function sendCancelledPromissoryNote(request) {
  const url = `${priceQuoteRootV1}/contracts/send-canceled-promissory-note`;
  const response = await sendCustomRequest(url, {}, request, 'post');
  if (!response.success) {
    const { errorCode, message } = response.data;
    throw new APIError(errorCode, message);
  }

  return response.data;
}
